const localStorageNames = {
  THEME: 'theme',
}

export default localStorageNames
